import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../config/config';

@Injectable({
  providedIn: 'root',
})
export class MeterAssignmentService {
  private pathApi = this.config.setting['pathApi'] + 'meterAssignment/';
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient, private config: AppConfig) {}

  public getAll(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, dataIn, { observe: 'response' });
  }

  public save(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}save`, dataIn, { observe: 'response' });
  }

  public delete(id: number): Observable<any> {
    return this.http.delete(`${this.pathApi}delete/${id}`, { observe: 'response' });
  }

  public toggleStatus(id: number): Observable<any> {
    return this.http.post(`${this.pathApi}toggleStatus/${id}`, null, { observe: 'response' });
  }

  public toggleAll(isDisabled: boolean): Observable<any> {
    return this.http.post(`${this.pathApi}toggleAll?isDisabled=${isDisabled}`, null, { observe: 'response' });
  }
}
